'use strict';

import {StructureSectionsNavigCtrl} from './structuresectionsnavigctrl.js';

export class ReportingSectionsNavigCtrl extends StructureSectionsNavigCtrl {

    reportingCurrentIndex = 0;

    init($scope, jsDataService) {
        this.$scope = $scope;
        let strNodeList = jsDataService.get('reportingStructureTreeNodeList', false);
        if (false !== strNodeList) {
            this.nodeList = strNodeList;
            this.navigationList = jsDataService.get('reportingNavigationList', false);
            let idx = jsDataService.get('reportingCurrentIndex', false);
            this.reportingCurrentIndex = (false !== idx) ? idx : 0;
        } else {
            this.makeStructureList(jsDataService.get('reportingstructuretree', {}));
            jsDataService.set('reportingStructureTreeNodeList', this.nodeList);
            jsDataService.set('reportingNavigationList', this.navigationList);
            jsDataService.set('reportingCurrentIndex', this.reportingCurrentIndex);
        }
    }

    nodeTitleFormated(node) {
        let nr = '';
        if (node.numbered == 1 && node.number !== '') {
            nr = node.number + ' ';
        }
        return nr + node.title;
    }

    actionPreview(ev, node) {
        if (this.isPreview(node)) {
            this.$scope.goUrl(node.preview_url);
        }
    }

    actionEdit(ev, node) {
        if (this.isEdit(node)) {
            this.$scope.goUrl(node.edit_url);
        }
    }

    isPreviousLink() {
        return (this.reportingCurrentIndex > 0);
    }

    isNextLink() {
        const listLength = this.navigationList ? this.navigationList.length : 0;
        return (this.reportingCurrentIndex >= 0 && this.navigationList && this.reportingCurrentIndex < (listLength - 1));
    }

    navPrevious() {
        if (this.isPreviousLink()) {
            const prev = this.navigationList[this.reportingCurrentIndex - 1];
            const url = this.getNavigationUrl(prev);
            if (url) {
                this.$scope.goUrl(url);
            }
        }
    }

    navNext() {
        if (this.isNextLink()) {
            const next = this.navigationList[this.reportingCurrentIndex + 1];
            const url = this.getNavigationUrl(next);
            if (url) {
                this.$scope.goUrl(url);
            }
        }
    }

    getNavigationUrl(node) {
        if (node) {
            if (typeof node.preview_url !== 'undefined' && node.preview_url) {
                return node.preview_url;
            }
            if (typeof node.edit_url !== 'undefined' && node.edit_url) {
                return node.edit_url;
            }
        }
        return '';
    }

    getPreviousLink() {
        if (this.isPreviousLink()) {
            return this.getNavigationUrl(this.navigationList[this.reportingCurrentIndex - 1]);
        }
        return '';
    }

    getNextLink() {
        if (this.isNextLink()) {
            return this.getNavigationUrl(this.navigationList[this.reportingCurrentIndex + 1]);
        }
        return '';
    }

    isPreview(node) {
        return (this.isAction(node) && typeof node.preview_url !== 'undefined');
    }

    isEdit(node) {
        return (this.isAction(node) && typeof node.edit_url !== 'undefined');
    }

    isAction(node) {
        return (typeof node.is_page !== 'undefined' &&
            (node.is_page === 1 ||
                node.is_page === '1' ||
                node.is_page === 'true' ||
                node.is_page === true));
    }

    isCurrent(node) {
        return (this.navigationList &&
            this.navigationList[this.reportingCurrentIndex] &&
            this.navigationList[this.reportingCurrentIndex].id === node.id);
    }
}
